<script>
	import Card from "./Card.svelte";

	let profile_img1 = "../../profile1.avif";
	let profile_img2 = "../../profile2.jpg";
	let profile_img3 = "../../profile3.jpg"
</script>
<main>
	<div id="main">
	<div id="radial">
	<div id="background">
		
	</div>
	</div>
</div>
	<div id="cards">
		<Card roper="Roper 001" profile_img={profile_img1}/>
		<Card roper="Roper 002" profile_img={profile_img2}/>
		<Card roper="Roper 003" profile_img={profile_img3}/>
	</div>

</main>

<style>
	main { height: 100%; }
	#main {
		background-image: url("../../background.jpg");
		background-repeat: no-repeat;
		background-attachment: fixed;
		background-position: center;
		background-size: cover;
		width:100%;
		height: 100%;
		position: fixed;
	}
	#radial {
		background: rgb(2,0,36);
		background: radial-gradient(circle, rgba(2,0,36,0) 0%, rgba(0,0,0,0.7315301120448179) 35%);
		background-attachment: fixed;
        width: 100%;
		height: 100%;
		position: fixed;
	}

	#background {
        background-image: url("../../background.png");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: center;
        background-size: contain;

        width: 100%;
		height: 100%;
		position: fixed;
    }
	#cards {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		height: 100%;
	}
</style>